import React from 'react';

const Features = () => <div className="contentblock animated fadeIn once">
    <img src="assets/features_t2.png" alt="big ass features infographic"></img>
</div>
export default Features